import { ACCOUNT_CATEGORY_OPTIONS } from "../Constants/accounting";

// The two categories a liability account can move between from Sunting Akun.
export const CURRENT_LIABILITY_CATEGORY = "OTHER_CURRENT_LIABILITIES";
export const LONG_TERM_LIABILITY_CATEGORY = "LONG_TERM_OBLIGATION";

// Income statement categories never carry an opening balance; the server
// rejects them, so Saldo Awal leaves them out.
export const PROFIT_LOSS_CATEGORIES = [
  "INCOME",
  "OTHER_INCOME",
  "COST_OF_GOODS_SOLD",
  "EXPENSE",
  "OTHER_EXPENSE",
];

export const isProfitLossAccount = (account) =>
  PROFIT_LOSS_CATEGORIES.includes(account?.category);

// Prior years' profit is entered here; its name differs per business type.
export const RETAINED_EARNINGS_CODE = "330100";

// Orders accounts by the chart of accounts category order, keeping their
// existing order within a category. Unknown categories go last.
export const sortByCategoryOrder = (accounts) => {
  const rank = (account) => {
    const index = ACCOUNT_CATEGORY_OPTIONS.findIndex(
      (option) => option.value === account?.category,
    );
    return index === -1 ? ACCOUNT_CATEGORY_OPTIONS.length : index;
  };
  return [...(accounts ?? [])].sort((a, b) => rank(a) - rank(b));
};

// Trade payables, customer deposits and the tax, payroll and BPJS payables
// are always due within a year, so they stay current.
const LOCKED_CURRENT_CODES = ["220100", "220201", "220203", "220204", "220205"];

export const canChangeLiabilityTerm = (account) => {
  if (!account) return false;
  if (
    account.category !== CURRENT_LIABILITY_CATEGORY &&
    account.category !== LONG_TERM_LIABILITY_CATEGORY
  ) {
    return false;
  }
  if (account.editable === false) return false;
  const code = String(account.code ?? "").replace(/\s/g, "");
  return !LOCKED_CURRENT_CODES.includes(code) && !code.startsWith("2205");
};

const sumTotals = (list) => list.reduce((sum, row) => sum + (row?.total ?? 0), 0);

// Splits the LIABILITIES rows of POST /balance-sheet into current and long-term
// blocks by each account's `term`. An account without `term` is current, so an
// older response still renders. The server totals win when they are present.
export const splitLiabilities = (items) => {
  const liabilities = (items ?? []).filter(
    (item) => item?.category === "LIABILITIES",
  );
  const accounts = liabilities.flatMap((item) => item.accounts || []);
  const currentAccounts = accounts.filter(
    (account) => account?.term !== "LONG_TERM",
  );
  const longTermAccounts = accounts.filter(
    (account) => account?.term === "LONG_TERM",
  );
  const serverTotal = (key, fallback) =>
    liabilities.some((item) => typeof item[key] === "number")
      ? liabilities.reduce((sum, item) => sum + (item[key] ?? 0), 0)
      : fallback;

  return {
    currentAccounts,
    longTermAccounts,
    currentTotal: serverTotal("currentTotal", sumTotals(currentAccounts)),
    longTermTotal: serverTotal("longTermTotal", sumTotals(longTermAccounts)),
    total: sumTotals(liabilities),
  };
};
